<script setup lang="ts">

import { PRICES } from '@presentation/Types/Settings';

import CarbucksProtectFeatures from './Components/CarbucksProtectFeatures.vue';

</script><template>

    <Page>

        <div class="grid grid-cols-12 justify-center items-center gap-16">

            <div class="col-span-5 2xl:col-span-6 scale-[75%] xl:scale-[80%] 2xl:scale-100">
                <table class="
                    uppercase text-xs md:text-sm 2xl:text-base 3xl:text-lg text-center w-full 
                    border-separate rounded-lg ring-4 ring-white shadow-xl">
            
                    <tbody>

                        <tr class="font-semibold">
                            <td class="bg-indigo-600 rounded-tl-lg p-1 md:p-4">Category<br/>1</td>
                            <td class="bg-indigo-600 p-1 md:p-4 border-gray-950">Category<br/>2</td>
                            <td class="bg-indigo-600 p-1 md:p-4 border-gray-950">Category<br/>3</td>
                            <td class="bg-indigo-600 rounded-tr-lg p-1 md:p-4">Category<br/>4</td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 md:p-3 lg:px-8 2xl:px-10 text-xs 3xl:text-sm align-top">
                                <div class="font-semibold mb-2">
                                    Everyday cars
                                </div>
                                <div>
                                    Toyota, 
                                    Kia, 
                                    Mitsubishi,
                                    Mazda,
                                    etc.
                                </div>
                            </td>

                            <td class="bg-white text-black p-1 md:p-3 border-gray-950 text-xs 3xl:text-sm align-top">
                                <div class="font-semibold mb-2">
                                    Chinese Brands
                                </div>
                                <div>
                                    BYD,
                                    MG,
                                    Haval,
                                    GWM, 
                                    etc.
                                </div>
                            </td>

                            <td class="bg-white text-black p-1 md:p-3 border-gray-950 text-xs 3xl:text-sm align-top">
                                <div class="font-semibold mb-2">
                                    Premium &amp; Commercial 
                                </div>
                                <div>
                                    VW,
                                    Cupra,
                                    Utes,
                                    Light Commercial Vehicles,
                                    etc.
                                </div>
                            </td>

                            <td class="bg-white text-black p-1 md:p-3 text-xs 3xl:text-sm align-top">
                                <div class="font-semibold mb-2">
                                    Luxury Brands
                                </div>
                                <div>
                                    Mercedes,
                                    BMW,
                                    Audi,
                                    etc.
                                </div>
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td colspan="4" class="bg-gray-200 text-black p-1 md:p-3 ">Dealer Wholesale Cost</td>
                        </tr>

                        <tr class="border-gray-950 font-bold text-base 2xl:text-lg">
                            <td class="bg-gray-200 text-indigo-500 p-1 md:p-3">${{ PRICES.Category1.Wholesale.toLocaleString() }}</td>
                            <td class="bg-gray-200 text-indigo-500 p-1 md:p-3 border-gray-950">${{ PRICES.Category2.Wholesale.toLocaleString() }}</td>
                            <td class="bg-gray-200 text-indigo-500 p-1 md:p-3  border-gray-950">${{ PRICES.Category3.Wholesale.toLocaleString() }}</td>
                            <td class="bg-gray-200 text-indigo-500 p-1 md:p-3">${{ PRICES.Category4.Wholesale.toLocaleString() }}</td>
                        </tr>

                        <tr class="border-gray-950">
                            <td colspan="4" class="bg-white p-1 md:p-3 text-black">Recommended Retail Price</td>
                        </tr>

                        <tr class="border-gray-950 font-bold text-emerald-500 text-base 2xl:text-lg">
                            <td class="bg-white rounded-bl-lg p-1 md:p-3">${{ PRICES.Category1.RRP.toLocaleString() }}</td>
                            <td class="bg-white p-1 md:p-3 border-gray-950">${{ PRICES.Category2.RRP.toLocaleString() }}</td>
                            <td class="bg-white p-1 md:p-3 border-gray-950">${{ PRICES.Category3.RRP.toLocaleString() }}</td>
                            <td class="bg-white rounded-br-lg p-1 md:p-3">${{ PRICES.Category4.RRP.toLocaleString() }}</td>
                        </tr>

                    </tbody>

                </table>

                <div class="mt-3 text-xs 2xl:text-base text-white/60 text-center">&gt; $650 margin on each contract</div>

                <div class="w-full h-8 absolute top-full translate-y-6"
                    style="background-image: radial-gradient( ellipse farthest-side at center, rgba( 0,0,0, 0.2 ) 0%, transparent 100%);" 
                />

            </div>

            <div class="col-span-7 2xl:col-span-6 scale-[80%] lg:scale-[90%] 2xl:scale-100 left-10">
                <CarbucksProtectFeatures
                    :show-conditions="true" 
                />
            </div>

        </div>


    </Page>

</template>